import { connect } from 'react-redux';

import BootstrapModalOutlet from './BootstrapModalOutlet';

const mapStateToProps = (state) => {
	return {
		showBackdrop: state.windowState.showBackdrop,
		showModal: state.windowState.showModal,
		modalPhotoUrl: state.windowState.modalPhotoUrl,
		modalPhotoTitle: state.windowState.modalPhotoTitle,
		modalComponent: state.windowState.modalComponent
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

const BootstrapModalOutletContainer = connect(mapStateToProps, mapDispatchToProps)(BootstrapModalOutlet);
export default BootstrapModalOutletContainer;



/** WEBPACK FOOTER **
 ** ./src/modal/BootstrapModalOutletContainer.js
 **/